import React from "react"
import { Box, Stack, Typography } from "@mui/material"
import { PencilRuler } from "@phosphor-icons/react"
import { GenericCircleIcon } from "./GenericCircleIcon"

export const GenericOngoing = ({ pageName = 'Page' }) => {
  return (
    <Box sx={{ height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Stack alignItems={'center'}>
        <GenericCircleIcon color={'primary.main'}>
          <PencilRuler size={52} />
        </GenericCircleIcon>
        <Typography variant="h5" fontWeight={800} margin={'10px 0 5px 0'}>{pageName} is ongoing</Typography>
        <Typography color="grey.dark">This page is currently under development</Typography>
      </Stack >
    </Box >
  )
};